import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  Input,
  InputSignal,
} from '@angular/core';
import { ContentType } from '../../pages/content-creation/content-creation';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { ToggleSwitchComponent } from '@kinomap-dev/ng-ui-lib/elements';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ColorService } from '../../services/color.service';
import { InputRadioElement } from '../input-radio-element/input-radio-element';
import { InputRadioElementItem } from '../../types/input-radio-element-item.type';
import { SpeedMode } from '../../types/speed-mode.type';
import { AudioMode } from '../../types/audio-mode.type';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';

@Component({
  selector: 'app-recommendation-block',
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    UpperFirstLetterPipe,
    IconComponent,
    ToggleSwitchComponent,
    InputRadioElement,
  ],
  templateUrl: './recommendation-block.html',
  styleUrl: './recommendation-block.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendationBlock {
  colorService: ColorService = inject(ColorService);

  readonly contentType: InputSignal<ContentType> = input.required<ContentType>();
  readonly recommendationForm: InputSignal<FormGroup> = input.required<FormGroup>();

  audioActive: boolean = false;
  recommendationModeActive: boolean = false;

  ngOnInit(): void {
    const speedMode = this.recommendationForm().get('speedMode')?.value;
    if (speedMode && speedMode !== 'none') {
      this.recommendationModeActive = true;
    }
    const audioMode = this.recommendationForm().get('audioMode')?.value;
    if (audioMode && audioMode !== 'none') {
      this.audioActive = true;
    }
  }

  textColor: string = this.colorService.getCssVariable('--text-color');
  textColor500: string = this.colorService.getCssVariable('--neutral-500');
  recommendationItemList: InputRadioElementItem<SpeedMode>[] = [
    {
      icon: 'star_stroke',
      value: 'original_speed',
      title: 'recommendation_block.original_speed',
      subTitle: 'recommendation_block.advice.original_speed',
      default: true,
    },
    {
      icon: 'challenge',
      value: 'variable_speed',
      title: 'recommendation_block.variable_speed',
      subTitle: 'recommendation_block.advice.variable_speed',
    },
  ];
  audioItemList: InputRadioElementItem<AudioMode>[] = [
    {
      icon: 'headset',
      value: 'optionnal',
      title: 'recommendation_block.optionnal',
      subTitle: 'recommendation_block.advice.optionnal',
      default: true,
    },
    {
      icon: 'sound_on',
      value: 'recommended',
      title: 'recommendation_block.recommended',
      subTitle: 'recommendation_block.advice.recommended',
    },
  ];

  audioChange(audioMode: string | number | boolean) {
    if (this.recommendationForm && this.recommendationForm().get('audioMode')) {
      this.recommendationForm().get('audioMode')?.setValue(audioMode.toString());
    }
  }

  recommendationChange(recommendationMode: string | number | boolean) {
    if (this.recommendationForm && this.recommendationForm().get('speedMode')) {
      this.recommendationForm().get('speedMode')?.setValue(recommendationMode.toString());
    }
  }

  recommendationModeSelection(recommendationMode: boolean) {
    this.recommendationModeActive = recommendationMode;
    if (!recommendationMode && this.recommendationForm) {
      this.recommendationForm().get('speedMode')?.setValue('none');
      return;
    }
    this.recommendationForm().get('speedMode')?.setValue('original_speed');
  }

  audioSelection(audioActive: boolean) {
    this.audioActive = audioActive;
    if (!audioActive && this.recommendationForm) {
      this.recommendationForm().get('audioMode')?.setValue('none');
      return;
    }
    this.recommendationForm().get('audioMode')?.setValue('optionnal');
  }
}
